import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import DocumentCell from "./DocumentCell";
import DocumentLinkCell from "./DocumentLinkCell";

export default class ListRow extends PureComponent {
  static propTypes = {
    item: PropTypes.object
  };

  static defaultProps = {
    item: {}
  };

  render() {
    const { item } = this.props;
    return (
      <div role="row" tabIndex="0" className="sorted-list__row">
        <DocumentCell className="--x17" item={item} />
        <DocumentLinkCell className="--x3" documentId={item.id} documentName={`${item.fileName}.${item.fileExtension}`} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Document/List/ListRow.js